(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nahla-collection-main"]) return;
  try {
    
  (function() {
    function init() {
      document.querySelectorAll('.nahla-collection:not([data-nahla-init])').forEach(section => {
        section.dataset.nahlaInit = '1';

        // Word-mask title reveal
        const title = section.querySelector('[data-nahla-words]');
        if (title && !title.dataset.split) {
          const text = title.textContent.trim();
          const words = text.split(/\s+/).slice(0, 4);
          title.innerHTML = words.map(w =>
            `<span data-nahla-word><span data-nahla-word-inner>${w}</span></span>`
          ).join(' ');
          title.dataset.split = '1';
        }
        requestAnimationFrame(() => requestAnimationFrame(() => section.classList.add('is-revealed')));

        // Sort: submit on change (reloads with ?sort_by=... query)
        const sortSelect = section.querySelector('[data-nahla-sort-select]');
        if (sortSelect) {
          sortSelect.addEventListener('change', () => {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', sortSelect.value);
            url.searchParams.delete('page');
            window.location.href = url.toString();
          });
        }

      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nahla-editorial"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init() {
      const sections = document.querySelectorAll('.nahla-editorial:not([data-nahla-init])');
      sections.forEach(section => {
        section.dataset.nahlaInit = '1';

        // Split heading text into masked words
        const heading = section.querySelector('[data-nahla-words]');
        if (heading && !heading.dataset.split) {
          const text = heading.textContent.trim();
          const words = text.split(/\s+/).slice(0, 8);
          heading.innerHTML = words.map(w =>
            `<span data-nahla-word><span data-nahla-word-inner>${w}</span></span>`
          ).join(' ');
          heading.dataset.split = '1';
        }
      });

      // Observe sections; add .is-revealed when they cross 18% into viewport
      const targets = document.querySelectorAll('.nahla-editorial:not(.is-revealed)');
      if (!targets.length) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

      targets.forEach(t => observer.observe(t));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nahla-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init() {
      const sections = document.querySelectorAll('.nahla-fp:not([data-nahla-init])');
      sections.forEach(section => {
        section.dataset.nahlaInit = '1';

        // Split title text into masked words
        const title = section.querySelector('[data-nahla-words]');
        if (title && !title.dataset.split) {
          const text = title.textContent.trim();
          const words = text.split(/\s+/).slice(0, 6);
          title.innerHTML = words.map(w =>
            `<span data-nahla-word><span data-nahla-word-inner>${w}</span></span>`
          ).join(' ');
          title.dataset.split = '1';
        }
      });

      const targets = document.querySelectorAll('.nahla-fp:not(.is-revealed)');
      if (!targets.length) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

      targets.forEach(t => observer.observe(t));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nahla-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init() {
      const heroes = document.querySelectorAll('.nahla-hero:not([data-nahla-init])');
      heroes.forEach(hero => {
        hero.dataset.nahlaInit = '1';

        // Split heading text into masked word wrappers
        const heading = hero.querySelector('[data-nahla-words]');
        if (heading && !heading.dataset.split) {
          const text = heading.textContent.trim();
          const words = text.split(/\s+/).slice(0, 10);
          heading.innerHTML = words.map(w =>
            `<span data-nahla-word><span data-nahla-word-inner>${w}</span></span>`
          ).join(' ');
          heading.dataset.split = '1';
        }

        // Trigger reveal class on next frame so transitions fire
        requestAnimationFrame(() => requestAnimationFrame(() => {
          hero.classList.add('is-revealed');
        }));

        // Magnetic CTA — gentle cursor pull
        const magnet = hero.querySelector('[data-nahla-magnetic]');
        if (magnet && !REDUCED) {
          let raf = null;
          magnet.addEventListener('mousemove', (e) => {
            const r = magnet.getBoundingClientRect();
            const x = e.clientX - r.left - r.width / 2;
            const y = e.clientY - r.top - r.height / 2;
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
              magnet.style.transform = `translate(${(x * 0.2).toFixed(2)}px, ${(y * 0.2).toFixed(2)}px)`;
            });
          });
          magnet.addEventListener('mouseleave', () => {
            if (raf) cancelAnimationFrame(raf);
            magnet.style.transition = 'transform 500ms cubic-bezier(0.16, 1, 0.3, 1)';
            magnet.style.transform = 'translate(0, 0)';
            setTimeout(() => { magnet.style.transition = ''; }, 500);
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nahla-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init() {
      const carousels = document.querySelectorAll('.nahla-pc:not([data-nahla-pc-init])');
      carousels.forEach(carousel => {
        carousel.dataset.nahlaPcInit = '1';

        const track = carousel.querySelector('[data-nahla-pc-track]');
        const prev = carousel.querySelector('[data-nahla-pc-prev]');
        const next = carousel.querySelector('[data-nahla-pc-next]');
        if (!track) return;

        function getCardWidth() {
          const card = track.querySelector('.nahla-pc__card');
          if (!card) return 320;
          const style = window.getComputedStyle(track);
          const gap = parseFloat(style.gap) || 24;
          return card.offsetWidth + gap;
        }

        function updateButtons() {
          if (!prev || !next) return;
          const max = track.scrollWidth - track.clientWidth;
          prev.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft >= max - 4;
        }

        if (prev) prev.addEventListener('click', () => {
          track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', () => {
          track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', () => {
          window.requestAnimationFrame(updateButtons);
        }, { passive: true });

        updateButtons();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nahla-product-main"]) return;
  try {
    
  (function() {
    function initProductSection(section) {
      if (section.dataset.nahlaInit) return;
      section.dataset.nahlaInit = '1';

      // ---- Word-mask title reveal ----
      const title = section.querySelector('[data-nahla-words]');
      if (title && !title.dataset.split) {
        const text = title.textContent.trim();
        const words = text.split(/\s+/).slice(0, 6);
        title.innerHTML = words.map(w =>
          `<span data-nahla-word><span data-nahla-word-inner>${w}</span></span>`
        ).join(' ');
        title.dataset.split = '1';
      }

      // trigger reveal on next frame
      requestAnimationFrame(() => requestAnimationFrame(() => section.classList.add('is-revealed')));

      // ---- Product variant data ----
      const variantScript = section.querySelector('[data-nahla-product-json]');
      const variants = variantScript ? JSON.parse(variantScript.textContent) : [];
      const optionButtons = section.querySelectorAll('[data-nahla-option-value]');
      const variantInput = section.querySelector('[data-nahla-variant-id]');
      const priceEl = section.querySelector('[data-nahla-price]');
      const compareEl = section.querySelector('[data-nahla-compare]');
      const atcPrice = section.querySelector('[data-nahla-atc-price]');
      const atcBtn = section.querySelector('[data-nahla-atc]');

      // Track selected options (start with the current variant's options)
      let selected = [];
      if (variants.length) {
        const cur = variants.find(v => String(v.id) === String(variantInput?.value));
        selected = cur ? [...cur.options] : [...variants[0].options];
      }

      function money(cents) {
        return (cents / 100).toFixed(2) + ' TND';
      }

      function findVariant() {
        return variants.find(v => v.options.every((opt, i) => opt === selected[i]));
      }

      function updateSelection() {
        const variant = findVariant();
        if (!variant) return;

        // update hidden input
        if (variantInput) variantInput.value = variant.id;

        // update price
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }
        if (atcPrice) atcPrice.textContent = money(variant.price);

        // update ATC state
        if (atcBtn) {
          if (variant.available) {
            atcBtn.disabled = false;
            const label = atcBtn.querySelector('.nahla-product__atc-label');
            if (label && !atcBtn.classList.contains('is-added')) label.textContent = 'Ajouter au panier';
          } else {
            atcBtn.disabled = true;
            const label = atcBtn.querySelector('.nahla-product__atc-label');
            if (label) label.textContent = 'Épuisé';
          }
        }

        // update selected-value label + button active state
        section.querySelectorAll('[data-nahla-option-selected]').forEach(el => {
          const idx = parseInt(el.dataset.optionIndex, 10);
          if (!isNaN(idx)) el.textContent = selected[idx] || '';
        });

        section.querySelectorAll('[data-nahla-option-value]').forEach(btn => {
          const idx = parseInt(btn.dataset.optionIndex, 10);
          const value = btn.dataset.value;
          btn.classList.toggle('is-selected', selected[idx] === value);
          btn.setAttribute('aria-checked', selected[idx] === value ? 'true' : 'false');
        });

        // update URL without reload
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      optionButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.dataset.optionIndex, 10);
          selected[idx] = btn.dataset.value;
          updateSelection();
        });
      });

      // ---- Thumbnails ----
      const mainImageWrap = section.querySelector('[data-nahla-main-image]');
      const mainImage = mainImageWrap?.querySelector('img');
      section.querySelectorAll('[data-nahla-thumb]').forEach(thumb => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.fullSrc;
          if (!src || !mainImage) return;
          mainImageWrap.classList.add('is-swapping');
          setTimeout(() => {
            mainImage.src = src;
            mainImage.removeAttribute('srcset'); // let fresh src take over
            mainImageWrap.classList.remove('is-swapping');
          }, 250);
          section.querySelectorAll('[data-nahla-thumb]').forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      // ---- Quantity buttons ----
      const qtyInput = section.querySelector('[data-nahla-qty-input]');
      section.querySelectorAll('[data-nahla-qty]').forEach(btn => {
        btn.addEventListener('click', () => {
          if (!qtyInput) return;
          const delta = parseInt(btn.dataset.nahlaQty, 10);
          const next = Math.max(1, parseInt(qtyInput.value, 10) + delta);
          qtyInput.value = next;
        });
      });

      // ---- Add-to-cart submission feedback ----
      const form = section.querySelector('.nahla-product__form');
      if (form) {
        form.addEventListener('submit', () => {
          if (atcBtn) atcBtn.classList.add('is-loading');
        });
      }
    }

    function init() {
      document.querySelectorAll('.nahla-product').forEach(initProductSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
